import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import typographyTheme from '../styles/typographyTheme';
var GridList = styled.ul.withConfig({
  displayName: "GridList",
  componentId: "sc-1w3ecv7-0"
})(["display:flex;flex-wrap:wrap;font-family:", ";font-size:", ";list-style:none;margin-bottom:0;padding-left:0;"], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, 'typography.base.fontSize', typographyTheme.typography.base.fontSize));
});
export default GridList;